import wordmarkLight from "@/assets/img/layout/stocko_black_logo_dashboard.svg";
import wordmarkDark from "@/assets/img/layout/stocko_white_logo_dashboard.svg";

/**
 * Full-page loading screen: centred wordmark, a single sweeping progress bar,
 * and a status line. Shown while the session and business are resolving.
 *
 * The bar is deliberately indeterminate - there is no meaningful percentage to
 * report, so it sweeps rather than pretending to measure progress.
 */
export default function LoadingScreen({ message = "Loading your dashboard..." }) {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-[#eaeef3] px-6 dark:bg-navy-900">
      <style>{`
        @keyframes stocko-load-sweep {
          0%   { width: 8%; }
          50%  { width: 72%; }
          100% { width: 92%; }
        }
        @media (prefers-reduced-motion: reduce) {
          .stocko-load-bar { animation: none !important; width: 70% !important; }
        }
      `}</style>

      <img
        src={wordmarkLight}
        alt="Stocko"
        className="mb-10 h-8 w-auto select-none dark:hidden"
        draggable="false"
      />
      <img
        src={wordmarkDark}
        alt="Stocko"
        className="mb-10 hidden h-8 w-auto select-none dark:block"
        draggable="false"
      />

      <div
        role="progressbar"
        aria-label={message}
        className="h-[7px] w-full max-w-[450px] overflow-hidden rounded-full bg-white dark:bg-navy-800"
      >
        <div
          className="stocko-load-bar h-full rounded-full bg-gradient-to-r from-[#9cc0fb] to-[#1a56db]"
          style={{ animation: "stocko-load-sweep 2.4s cubic-bezier(0.4, 0, 0.2, 1) forwards" }}
        />
      </div>

      <p className="mt-7 text-[17px] text-[#2b2b2b] dark:text-gray-300">{message}</p>
    </div>
  );
}
